import * as ActionTypes from "constants/ActionTypes";

export const storyLoaded = (story) => ({
  type: ActionTypes.STORY_LOADED,
  story,
});

export const updateHotspot = (hotspot) => ({
  type: ActionTypes.UPDATE_HOTSPOT,
  hotspot,
});

export const addHotspotToChapter = (hotspot, chapterId) => ({
  type: ActionTypes.ADD_HOTSPOT,
  hotspot,
  chapterId,
});
